import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  slot: "footer",
  class: "dialog-footer"
};
import { ref, reactive } from 'vue';
import api from '@/server/request/api';
import { ElMessage } from "element-plus";
export default /*@__PURE__*/_defineComponent({
  __name: 'add',
  emits: ['userUpdated'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dialogVisible = ref(false);
    const emit = __emit;
    const form = ref({
      username: '',
      system: '',
      dept: '',
      status: false,
      password: ''
    });
    const title = ref('新增用户');
    const formRef = ref();
    const state = reactive({
      formItems: [{
        required: true,
        message: '请输入用户名',
        trigger: 'blur'
      }, {
        required: true,
        message: '请选择角色',
        trigger: 'change'
      }, {
        required: true,
        message: '请选择部门',
        trigger: 'change'
      }, {
        required: true,
        message: '请选择状态',
        trigger: 'change'
      }, {
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }],
      departmentOptions: [{
        label: '大连技术研发部',
        value: '大连技术研发部'
      }, {
        label: '销售部',
        value: '销售部'
      }, {
        label: '重庆技术部',
        value: '重庆技术部'
      }, {
        label: '产品部',
        value: '产品部'
      }, {
        label: '运维部',
        value: '运维部'
      }]
    });
    // Start of Selection
    const submitForm = () => {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validate(valid => {
        if (valid) {
          api.editUser(form.value).then(res => {
            if (res.code === 200) {
              ElMessage.success('用户信息提交成功');
              handleClose(); // Close the dialog after successful submission
              // Emit an event to notify the parent component about the user update
              emit('userUpdated');
            } else {
              ElMessage.error(res.msg);
            }
          }).catch(() => {
            ElMessage.error('提交失败，请重试');
            console.error('Error submitting form:');
          });
        } else {
          ElMessage.warning('请检查表单填写是否正确');
          return false;
        }
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
      form.value = {
        username: '',
        system: '',
        dept: '',
        status: false,
        password: ''
      };
    };
    // Expose a method to open the dialog
    __expose({
      openDialog: value => {
        console.log('openDialog', value);
        dialogVisible.value = true;
        if (value) {
          title.value = '编辑用户';
          form.value = value;
        } else {
          title.value = '新增用户';
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: title.value,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => dialogVisible.value = $event),
        width: "500",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "username",
            rules: state.formItems[0]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.username = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "角色",
            prop: "system",
            rules: state.formItems[1]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.system,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.system = $event),
              placeholder: "请选择角色",
              style: {
                "width": "100%"
              },
              clearable: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "管理员",
                value: true
              }), _createVNode(_component_el_option, {
                label: "普通用户",
                value: false
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "部门",
            prop: "dept",
            rules: state.formItems[2]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.dept,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.dept = $event),
              placeholder: "请选择部门",
              style: {
                "width": "100%"
              },
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.departmentOptions, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "密码",
            prop: "password"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              type: "password",
              modelValue: form.value.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.password = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "status",
            rules: state.formItems[3]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.value.status,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.status = $event),
              "active-color": "#13ce66",
              "inactive-color": "#ff4949"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("取 消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("确 定", -1)]))]),
          _: 1
        })])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }
});